<template>
  <div class="form-box">
    <el-form :model="obj" :rules="formRules" ref="sampleForm" label-width="0px" class="order-sample-ruleForm">
      <el-descriptions class="margin-top" :column="3" border>
        <el-descriptions-item :span="2">
          <template slot="label">
            <span class="required"> 样品名称 </span></template>
          <el-form-item label="" prop="SampleName">
            <el-input size="small" v-model="obj.SampleName" placeholder="请输入样品名称">
            </el-input>
          </el-form-item>
        </el-descriptions-item>
        <el-descriptions-item>
          <template slot="label">
            <span class="required"> 样品数量 </span></template>
          <el-form-item label="" prop="SampleNum">
            <el-input-number size="small" v-model="obj.SampleNum" :min="1" placeholder="请输入样品数量">
            </el-input-number>
          </el-form-item>
        </el-descriptions-item>
        <el-descriptions-item>
          <template slot="label">
            <span class="required"> 送样方式 </span></template>
          <el-form-item label="" prop="SendSampleType">
            <el-select v-model="obj.SendSampleType" placeholder="请选择送样方式" clearable filterable
              popper-class="relative-select" :popper-append-to-body="false">
              <el-option label="自送" :value="0"> </el-option>
              <el-option label="邮寄" :value="1"> </el-option>
            </el-select>
          </el-form-item>
        </el-descriptions-item>
        <template v-if="obj.SendSampleType">
          <el-descriptions-item>
            <template slot="label">
              <span :class="{ required: expressInformationBoolean }">
                快递公司
              </span></template>
            <el-form-item label="" prop="SedDHL">
              <el-select v-model="obj.SedDHL" placeholder="请选择快递公司" clearable filterable popper-class="relative-select"
                :popper-append-to-body="false">
                <el-option v-for="item in ExpressCorporationList" :key="item.ItemValue" :label="item.ItemName"
                  :value="item.ItemValue">
                </el-option>
              </el-select>
            </el-form-item>
          </el-descriptions-item>
          <el-descriptions-item>
            <template slot="label">
              <span :class="{ required: expressInformationBoolean }">
                快递单号
              </span></template>
            <el-form-item label="" prop="ExpressNum">
              <el-input size="small" v-model="obj.ExpressNum" placeholder="请输入快递单号">
              </el-input>
            </el-form-item>
          </el-descriptions-item>
        </template>
        <el-descriptions-item :span="3">
          <template slot="label"> <span class=""> 送样备注 </span></template>
          <el-form-item label="" prop="SedRemark">
            <el-input size="small" v-model="obj.SedRemark" placeholder="请输入送样备注">
            </el-input>
          </el-form-item>
        </el-descriptions-item>
        <!-- 样品处理方式 -->
        <el-descriptions-item>
          <template slot="label">
            <span class="required"> 样品处理方式 </span></template>
          <el-form-item label="" prop="SampleProcessing">
            <el-select v-model="obj.SampleProcessing" placeholder="请选择样品处理方式" clearable filterable
              popper-class="relative-select" :popper-append-to-body="false">
              <el-option v-for="item in SampleProcessingList" :key="item.ItemValue" :label="item.ItemName"
                :value="item.ItemValue">
              </el-option>
            </el-select>
          </el-form-item>
        </el-descriptions-item>
        <template v-if="obj.SampleProcessing.toString() === '3'">
          <el-descriptions-item>
            <template slot="label">
              <span class="required"> 返样联系人 </span></template>
            <el-form-item label="" prop="BackLinker">
              <el-input size="small" v-model="obj.BackLinker" placeholder="请输入返样联系人">
              </el-input>
            </el-form-item>
          </el-descriptions-item>
          <el-descriptions-item>
            <template slot="label">
              <span class="required"> 联系人电话 </span></template>
            <el-form-item label="" prop="BackLinkTel">
              <el-input size="small" v-model="obj.BackLinkTel" placeholder="请输入联系人电话">
              </el-input>
            </el-form-item>
          </el-descriptions-item>
          <el-descriptions-item :span="2">
            <template slot="label">
              <span class="required"> 返样地址 </span></template>
            <el-form-item label="" prop="BackAddress">
              <el-input size="small" v-model="obj.BackAddress" placeholder="请输入返样地址">
                <el-link slot="prepend" :underline="false" type="primary" size="mini" title="从我的地址中选择"
                  @click="OnOpenAddressList()">
                  <strong style="font-size: 16px"><i class="text-success bi-send-fill" /></strong>
                </el-link>
                <el-link slot="append" :underline="false" type="error" size="mini" title="保存为新地址">
                  <strong style="font-size: 16px"><i class="text-error bi-send-plus-fill" /></strong>
                </el-link>
              </el-input>
            </el-form-item>
          </el-descriptions-item>
        </template>
      </el-descriptions>
    </el-form>
    <div class="msg-box">
      <h4 class="text-error">
        注：当用户自取样品时，请于30日内取回，否则实验室自行处理！
      </h4>
    </div>

    <el-dialog title="选择地址" top="10vh" custom-class="address-select-wnd" :modal="false" :visible.sync="dialogVisible"
      width="720px">
      <el-table :data="myAddressList" highlight-current-row ref="addressTable" @row-click="onAddressTableRowClick"
        style="width: 100%">
        <el-table-column prop="LinkTel" label="电话" width="180">
        </el-table-column>
        <el-table-column prop="Linker" label="姓名" width="180">
        </el-table-column>
        <el-table-column prop="Address" label="地址">
        </el-table-column>
      </el-table>
      <span slot="footer" class="dialog-footer">
        <el-button size="small" icon="el-icon-close" @click="dialogVisible = false">取 消</el-button>
        <el-button size="small" icon="el-icon-check" type="primary" @click="onArressSelected()">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { GetItemDetailList, GetList } from "@/api/general-api"

export default {
  name: 'SampleEditForm',
  props: {
    obj1: {},
  },
  data() {
    var validateExpressNum = (rule, value, callback) => {
      if (!value) {
        callback(new Error('请输入快递单号'));
      } else {
        if (/[\u4E00-\u9FA5]/g.test(value)) {
          callback(new Error('快递单号不能输入汉字!'));
        } else {
          callback();
        }
      }
    };
    return {
      dialogVisible: false,
      currentRow: null,
      SampleProcessingList: [],
      ExpressCorporationList: [],
      expressInformationBoolean: true,
      obj: {
        SampleName: null,// --样品名称
        SampleNum: null,// --样品数量
        SedDHL: null,// --快递公司
        SedRemark: null,// --送样备注
        ExpressNum: null,// --寄样快递单号
        SampleProcessing: "3",// --样品处理方式,
        SendSampleType: 1,// -- 是否邮寄送样
        BackLinker: null,
        BackLinkTel: null,
        BackAddress: null,
      },
      formRules: {
        SampleName: [
          { required: true, message: '请输入样品名称', trigger: 'blur' },
        ],
        SampleNum: [
          { required: true, message: '请输入样品数量', trigger: 'blur' },
        ],
        SedDHL: [
          { required: true, message: '请输入快递公司名称', trigger: 'change' },
        ],
        ExpressNum: [
          { required: true, trigger: 'blur', validator: validateExpressNum },
        ],
        SampleProcessing: [
          { required: true, message: '请选择样品处理方式', trigger: 'change' },
        ],
        BackLinker: [
          { required: true, message: '请输入返样联系人', trigger: 'blur' },
        ],
        BackLinkTel: [
          { required: true, message: '请输入返样联系人电话', trigger: 'blur' },
        ],
        BackAddress: [
          { required: true, message: '请输入返样地址', trigger: 'blur' },
        ],
      },
      myAddressList: []
    }
  },
  created() {
    GetItemDetailList({ ItemCode: 'SampleProcessing' }).then(res => {
      if (res.success) {
        this.SampleProcessingList = res.data
      }
    })
    GetItemDetailList({ ItemCode: 'ExpressCorporation' }).then(res => {
      if (res.success) {
        this.ExpressCorporationList = res.data
      }
    })
    this.handleGetList()
  },
  mounted() {
    if (this.obj1.SampleName) {
      this.obj = this.obj1
    }

  },
  methods: {
    onAddressTableRowClick(row) {
      this.currentRow = row;
    },
    OnOpenAddressList() {
      this.dialogVisible = true;
    },
    onArressSelected() {
      if (!this.currentRow) {
        return this.$message.error("请先选择一行地址信息！");
      }

      this.obj.BackLinker = this.currentRow.Linker
      this.obj.BackLinkTel = this.currentRow.LinkTel
      this.obj.BackAddress = this.currentRow.Address
      this.dialogVisible = false;
    },
    GetData() {
      let _b = true
      this.$refs.sampleForm.validate((valid) => {
        _b = _b && valid
      })
      if (_b) {
        return { ...this.obj }
      }
    },
    handleGetList() {
      const queryParam = {
        Name: 'UserAddress',
        currentPage: 1,
        pageSize: 999,
        orderField: 'CreateTime',
        orderType: 'descend'
      }
      GetList(queryParam).then((res) => {
        if (res.success) {
          this.myAddressList = res.data.rows
        } else {
          this.$message.error(res.msg)
        }
      })
    },
  },

}
</script>

<style lang="scss">
.el-dialog.address-select-wnd {
  margin-top: 20vh !important;
}

.form-box {
  padding: 0px;
}

.order-sample-ruleForm {
  .el-form-item {
    margin-bottom: 12px !important;
  }

  .el-descriptions-item__cell {
    padding: 0px 5px !important;
  }

  .required {
    &::after {
      content: "*";
      color: #c10015;
      font-size: 20px;
      font-weight: bold;
    }
  }
}

.msg-box {
  margin: 30px 0;
  padding: 10px 20px;
  background: #f0f0f0;
}
</style>